import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { BehaviorSubject, EMPTY, Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { AuthActions } from '../../shared/store/auth/auth.actions';
import { AuthSelectors } from '../../shared/store/auth/auth.selectors';

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  private refreshingToken = false;

  private refreshTokenSubject: BehaviorSubject<boolean | null> =
    new BehaviorSubject<boolean | null>(null);

  constructor(private store: Store) {}

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: any) => {
        if (
          error instanceof HttpErrorResponse &&
          [401].includes(error.status)
        ) {
          if (this.refreshingToken) {
            return this.refreshTokenSubject.pipe(
              filter(result => result !== null),
              take(1),
              switchMap(success => {
                if (success) {
                  return next.handle(this.addAuthenticationToken(request));
                }
                return EMPTY;
              })
            );
          } else {
            this.refreshingToken = true;
            this.refreshTokenSubject.next(null);

            return this.store.dispatch(new AuthActions.RefreshToken()).pipe(
              switchMap(() => {
                this.refreshingToken = false;
                this.refreshTokenSubject.next(true);

                return next.handle(this.addAuthenticationToken(request));
              }),

              catchError(() => {
                this.refreshingToken = false;
                this.refreshTokenSubject.next(false);
                this.store.dispatch(new AuthActions.Logout());
                return EMPTY;
              })
            );
          }
        }

        return throwError(error);
      })
    );
  }

  private addAuthenticationToken(request: HttpRequest<unknown>) {
    const token = this.store.selectSnapshot(AuthSelectors.token);

    return !token
      ? request
      : request.clone({
          setHeaders: {
            Authorization: 'Bearer ' + token,
          },
        });
  }
}
